import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { trackCookieConsentAnalytics } from 'analytics/adCampaigns/trackCookieConsentAnalytics';
import { Translator, PureTranslator } from 'ggApp/modules/translator';

import CloseSmall from 'ggApp/shared/icons/CloseSmall';

import { withCookieConsentActions } from '../../enhancers';
import CookiePolicySettingsForm from '../settingsForm';
import { registerCookiePreferences, syncGoogleConsentState } from '../../tracking';

import {
    StyledModal,
    ModalHeader,
    ModalHeaderText,
    AcceptButton,
    SaveButton,
    CloseWrapper,
} from './styles';

const cookieExpiry = new Date();
cookieExpiry.setFullYear(cookieExpiry.getFullYear() + 1);

/**
 * CookiePolicyModal
 * This component renders Grover Cookie Policy settings
 * A user could specify which cookie types are allowed to use
 * @class CookiePolicyModal
 * @extends {PureComponent}
 */
@withCookieConsentActions
class CookiePolicyModal extends PureComponent {
    handleAcceptAll = () => {
        const { acceptAll, handleModalClose } = this.props;
        acceptAll();
        handleModalClose();
    };

    handleFormSubmit = (values) => {
        const { onCustomSave, updateCookiePolicySettings, handleModalClose } = this.props;

        const reduxStorePayload = {
            preferenceCookieConsent: values.preferenceCookie,
            statisticsCookieConsent: values.statisticsCookie,
            marketingCookieConsent: values.marketingCookie,
            consentTimestamp: Date.now(),
            hasConsent: true,
            consentExpiration: cookieExpiry,
        };
        const cookieConsentState = {
            preferenceCookie: values.preferenceCookie,
            statisticsCookie: values.statisticsCookie,
            marketingCookie: values.marketingCookie,
        };
        syncGoogleConsentState(cookieConsentState);
        updateCookiePolicySettings(reduxStorePayload);
        registerCookiePreferences(reduxStorePayload);
        trackCookieConsentAnalytics({
            strict: 'yes',
            functional: values.preferenceCookie ? 'yes' : 'no',
            performance: values.statisticsCookie ? 'yes' : 'no',
            profiling: values.marketingCookie ? 'yes' : 'no',
        });
        if (!values.preferenceCookie || !values.statisticsCookie || !values.marketingCookie) {
            onCustomSave(true);
        }

        if (values.marketingCookie) {
            window.location.reload();
        }

        if (typeof handleModalClose === 'function') {
            handleModalClose();
        }
    };

    render() {
        const {
            submitForm,
            modalRef,
            activeStore: { country_code: storeCode },
            handleModalClose,
            ...restProps
        } = this.props;

        return (
            <StyledModal {...restProps} modalRef={modalRef}>
                <CloseWrapper onClick={handleModalClose}>
                    <CloseSmall />
                </CloseWrapper>

                <ModalHeader>
                    <PureTranslator tk="COOKIE_POLICY_MODAL_HEADER" />
                </ModalHeader>

                <ModalHeaderText>
                    <Translator
                        tk="COOKIE_POLICY_MODAL_TEXT"
                        withValues={{ storeCode: storeCode?.toLowerCase() }}
                    />
                </ModalHeaderText>

                <AcceptButton color="black" onClick={this.handleAcceptAll}>
                    <PureTranslator tk="NEW_COOKIE_POLICY_ACCEPT_ALL_COOKIES" />
                </AcceptButton>

                <CookiePolicySettingsForm onSubmit={this.handleFormSubmit} />

                <SaveButton onClick={submitForm}>
                    <PureTranslator tk="NEW_COOKIE_POLICY_SAVE_PREFERENCES" />
                </SaveButton>
            </StyledModal>
        );
    }
}

CookiePolicyModal.propTypes = {
    submitForm: PropTypes.func.isRequired,
    modalRef: PropTypes.func.isRequired,
    onConsent: PropTypes.func,
    activeStore: PropTypes.shape({}).isRequired,
};

CookiePolicyModal.defaultProps = {
    onConsent: () => {},
};

export default CookiePolicyModal;
